import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(value: any, args?: any): string {
    if (!value) {
      return '';
    }

    return value.phones && value.phones[0] ? value.phones[0].number : '';
  }
}
